import React, { useMemo } from "react";

import { AddNew } from "../../../../components/svg/svgImageList";
import {
  AssignSewerObjectsToAssignedJob,
  AssignSewerObjectsToJob as AssignSewerObjectsToJobPermission,
} from "../../../../services/authorization/Permissions";
import Button from "../../../../components/button/Button";
import useThemeService from "../../../../services/theme-service/ThemeService";
import useModal from "../../../../components/dialog/useModal";
import { AddExistingSewerObjectsToJobModal } from "../../components/Dialogs";
import { permissionsService } from "../../../../services/authorization/UserPermissionsService";
import { JobSewerObjectsStorage } from "../../../../services/sewer-object/JobSewerObjectsStorage";

interface AssignSewerObjectsToJobProps {
  isJobAssignedToProject: boolean;
  reloadSewerObjectsMap(): Promise<void>;
  jobSewerObjectsStorage: JobSewerObjectsStorage;
  currentUserAssignedToJob: boolean;
}

export function AssignSewerObjectsToJob({
  isJobAssignedToProject,
  reloadSewerObjectsMap,
  jobSewerObjectsStorage,
  currentUserAssignedToJob,
}: AssignSewerObjectsToJobProps) {
  const { themeClass } = useThemeService();

  const { isVisible, toggleModal } = useModal();

  const assignSewerObjectsToJobEnabled = useMemo(
    () =>
      (permissionsService.userHasPermissionTo(AssignSewerObjectsToJobPermission) ||
        (permissionsService.userHasPermissionTo(AssignSewerObjectsToAssignedJob) &&
          currentUserAssignedToJob)) &&
      isJobAssignedToProject,
    [currentUserAssignedToJob, isJobAssignedToProject]
  );

  return (
    <>
      <Button
        id="button-add-sewer-objects"
        icon={{
          svg: AddNew,
          textKey: "job.AddExistingSewerObjectsButton.label",
          textClass: "actions-header-button-label",
          className: themeClass(["icon-add-new"]),
        }}
        disabled={!assignSewerObjectsToJobEnabled}
        onClick={toggleModal}
      />
      <AddExistingSewerObjectsToJobModal
        jobSewerObjectsStorage={jobSewerObjectsStorage}
        isVisible={isVisible}
        toggleModal={toggleModal}
        reloadSewerObjectsMap={reloadSewerObjectsMap}
      />
    </>
  );
}
